const translation = {
  common: {
    submit: 'Finalizar',
    back: 'Volver',
    ok: 'OK',
    save: 'Guardar',
    cancel: 'Cancelar',
    send: 'Enviar',
    next: 'Siguiente',
    advance: 'Continuar',
    yes: 'Sí',
    notApplicable: 'No aplicable',
    patient: 'Paciente',
    inProgress: 'en curso',
    hospitalLogoAlt: 'Logotipo del hospital',
  },
  validation: {
    required: 'Campo obligatorio',
    cpfInvalid: 'CPF inválido',
    selectAtLeastOneItem: '¡Es necesario seleccionar al menos un ítem!',
    mustSelectOneItem: '¡Debe seleccionar al menos un ítem!',
    integerQuantityOnly: '¡Solo se pueden solicitar cantidades enteras!',
    quantityLessThan: 'La cantidad debe ser menor que {{max}}.',
    quantityGreaterThan: 'La cantidad debe ser mayor que {{min}}.',
    quantityBetween: 'La cantidad debe estar entre {{min}} y {{max}}.',
  },
  language: {
    selector: {
      open: 'Seleccionar idioma',
    },
    modal: {
      title: 'Selector de idioma',
      subtitle: 'Seleccione el idioma de su preferencia.',
      save: 'Guardar',
    },
  },
  welcome: {
    title: '¡Bienvenido(a)!',
    body: 'Para empezar a usar la app, necesitamos que confirme si usted es el <strong>paciente</strong> o el <strong>acompañante</strong>.',
    bodyExtra:
      '¡Usamos esta información para garantizar que tenga la mejor experiencia!',
    userType: {
      patient: 'Soy paciente',
      companion: 'Soy acompañante',
    },
  },
  login: {
    pageTitle: 'Confirme su identidad',
    illustrationAlt:
      'Ilustración de profesionales de la salud listos para atender',
    almostThere: 'Ya casi...',
    companionInstructions:
      'Para acceder al sistema, por favor, escriba abajo su nombre y el <strong>número de atención</strong> ubicado en la pulsera de identificación de la persona acompañada, o el <strong>código de acceso</strong> ubicado debajo del código QR, según la indicación del personal del hospital.',
    patientInstructions:
      'Para acceder al sistema, por favor, escriba abajo su <strong>número de atención</strong>, ubicado en la pulsera de identificación, o el <strong>código de acceso</strong> ubicado debajo del código QR, según la indicación del personal del hospital.',
    fields: {
      name: 'Su nombre',
      admission: 'Número de atención',
      companionBirthDate: '¿Cuál es la fecha de nacimiento del paciente?',
      patientBirthDate: '¿Cuál es su fecha de nacimiento?',
    },
  },
  home: {
    pageTitle: 'Inicio - Quality24',
    heading: '¿Cómo podemos ayudar?',
    cards: {
      nurse: 'Llamar enfermería',
      infrastructure: 'Solicitar {{service}}',
      feedbackFallback: 'Felicitaciones y reclamos',
    },
  },
  greeting: {
    morning: 'Buenos días',
    afternoon: 'Buenas tardes',
    evening: 'Buenas noches',
  },
  nav: {
    home: 'Inicio',
    orders: 'Mis llamados',
  },
  errors: {
    loadAdmission:
      'No fue posible cargar su internación. Por favor, verifique sus datos y su conexión a internet.',
    requestFailed:
      'No fue posible realizar su solicitud. Por favor, inténtelo de nuevo.',
    surveyRequestFailed:
      'No fue posible realizar su solicitud. Por favor, inténtelo de nuevo.',
    coverageCheckFailed:
      'No fue posible verificar la cobertura de su atención. Inténtelo de nuevo.',
    cancelOrderFailed:
      'Error al cancelar el llamado. Inténtelo de nuevo. Si el error persiste, póngase en contacto con el soporte.',
    genericRequest:
      'Hubo un error en la solicitud. Por favor, inténtelo de nuevo.',
    serviceUnavailableAtThisTime:
      'Esta categoría de servicio no está disponible en este horario.',
  },
  payment: {
    status: {
      awaitingPayment: 'Pago pendiente',
      paid: 'Pagado',
      denied: 'Denegado',
      expired: 'Expirado',
      voided: 'Anulado',
      notCompleted: 'No finalizado',
      authorized: 'Autorizado',
      refund: 'Devolución',
    },
  },
  pain: {
    none: 'Sin dolor',
    mild: 'Leve',
    moderate: 'Moderado',
    severe: 'Severo',
    verySevere: 'Muy severo',
    worst: 'El peor dolor posible',
  },
  rating: {
    terrible: 'Pésimo',
    bad: 'Malo',
    regular: 'Regular',
    good: 'Bueno',
    great: 'Excelente',
  },
  maintenance: {
    title: 'Este servicio está en mantenimiento.',
    body: 'Por favor, espere para utilizarlo.',
  },
  survey: {
    improvements: {
      question:
        'En su opinión, ¿cuáles de los ítems a continuación podrían mejorarse?',
      subtitle: 'Seleccione cuantos considere necesarios.',
    },
    nav: {
      progress: 'Progreso de la encuesta',
    },
    notification: {
      text: '¿Qué tal contarnos <strong>cómo fue su experiencia</strong> este {{day}}?',
      cta: 'haga clic para responder',
    },
    comment: {
      label: 'Deje su comentario abajo:',
    },
    success: '¡Muchas gracias! Su evaluación fue recibida con éxito.',
  },
  dailySurvey: {
    pageTitle: 'Evaluación diaria - Quality24',
    confirmFinishTitle:
      '¿Está seguro de que desea finalizar y enviar esta evaluación?',
    noAnswersTitle: '¡No respondió ninguna pregunta!',
    cancelEvaluation: 'Cancelar evaluación',
    reviewQuestions: 'Revisar preguntas',
    confirmFinishBody:
      'Si desea revisar o cambiar alguna respuesta, haga clic en "Cancelar". De lo contrario, haga clic en "Enviar".',
    noAnswersBody: '¿Desea cancelar esta evaluación o revisar las preguntas?',
    respondNow: 'Responder ahora',
    respondLater: 'Responder más tarde',
    declineToAnswer: 'No quiero responder',
  },
  callEvaluation: {
    evaluate: 'Evaluar',
    title: 'Evalúe su llamado',
    message:
      '¿Qué nota le daría a su experiencia durante la resolución de este llamado?',
    comment: 'Comentario',
    skip: 'No quiero evaluar',
  },
  alerts: {
    noActive: 'No hay llamados activos',
    noResolved: 'No existen llamados resueltos',
    viewDetails: 'Ver detalles',
    resolvedAt: 'Resuelto a las {{time}}',
    responsible: 'Responsable: {{name}}',
    cancelledToast:
      'Su llamado de "{{reason}}" fue cancelado con el motivo "{{cancelReason}}".',
    notInformed: 'No informado',
  },
  order: {
    category: {
      nursing: 'enfermería',
    },
    section: {
      request: 'Solicitar {{category}}',
      selectOptionToOpen: 'Seleccione una opción abajo para abrir el llamado',
    },
    createRequest: 'Crear solicitud',
    selectOption: 'Seleccione una opción',
    openCall: 'Abrir llamado',
    fillBelow: 'Complete a continuación',
    selectReason: 'Seleccione uno de los motivos abajo:',
    details: {
      pageTitle: 'Detalles de la solicitud - Quality24',
      /** Joins a localized date and time — `L` and `LTS` in moment */
      dateAtTime: '{{date}} a las {{time}}',
      date: 'Fecha',
      placed: 'Pedido realizado',
      paymentApproved: 'Pago aprobado',
      inProgress: 'En curso',
      cancelled: 'Cancelado',
      closed: 'Cerrado',
      order: 'Pedido',
      items: 'Ítems del pedido',
      total: 'Total',
      totalValue: 'Valor total',
      cancelOrder: 'Cancelar pedido',
      payNow: 'Pagar ahora',
    },
    tracking: {
      pageTitle: 'Solicitudes - Quality24',
      open: 'Abiertos ({{count}})',
      finished: 'Finalizados ({{count}})',
    },
    rating: {
      pageTitle: 'Evaluación del llamado - Quality24',
      messageWithResolver:
        "¿Cómo evalúa su experiencia en la resolución del llamado de '{{reason}}', resuelto por {{resolver}}?",
      message:
        "¿Cómo evalúa su experiencia en la resolución del llamado de '{{reason}}'?",
    },
  },
  hospitalInfo: {
    additionalInfo: 'Información adicional',
    learnMore: 'Saber más',
    pageTitle: 'Información general - Quality24',
  },
  customData: {
    generalInfo: 'Información general',
    otherServices: 'Otros servicios',
  },
  integration: {
    notFound: 'La atención informada no fue encontrada.',
    loading: 'Espere mientras cargamos su atención...',
  },
  lgpd: {
    consentSuccess:
      'Usted aceptó los términos de protección de datos. ¡Bienvenido(a)!',
    agree: 'Aceptar',
    refuse: 'Rechazar',
    refuseAndLogout: 'Rechazar y cerrar sesión',
    confirmRefuse:
      '¿Está seguro? Al rechazar los términos, se cerrará su sesión en la aplicación.',
  },
} as const;

export default translation;
